import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DoubleFlatPiercingImage from '../../Assets/Piercing Services/double flat piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DoubleFlatPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Double Flat Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Double Flat Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Double Flat Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DoubleFlatPiercingImage} alt="Double Flat Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Double Flat Piercing</h3>

          <p>
            Elevate your ear styling with our professional double flat piercing services in the UAE, available at an affordable price of 250 AED. Double flat piercing is a modern and edgy cartilage piercing that features two piercings placed on the flat area of the upper ear, creating a layered and visually striking look. This stylish option is perfect for individuals who want to add depth and personality to their ear design while maintaining a clean and contemporary aesthetic. Whether you prefer minimal studs for a sleek appearance or a mix of bold jewelry for a statement look, our expert specialists ensure precise placement for a balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each double flat piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. With advanced techniques designed to reduce discomfort, we ensure that the procedure is quick, efficient, and as pain-minimized as possible, even with two piercings.
          </p>

          <p>
            Double flat piercing is ideal for those who want a bold and fashionable ear style that stands out. The flat area of the ear provides a wide surface, making it perfect for creative jewelry arrangements and layered designs. This piercing pairs beautifully with other styles such as helix, conch, or lobe, allowing you to create a fully customized and curated ear look. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry combinations to suit your ear structure and personal style.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process. Our goal is to deliver not only a stylish result but also a safe and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating, especially when getting multiple piercings, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience.
          </p>

          <p>
            Aftercare is an essential part of maintaining your double flat piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our double flat piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted double flat piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a commitment to customer satisfaction, we help you achieve an edgy and modern ear look effortlessly. Book your double flat piercing appointment today and transform your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Double Flat Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DoubleFlatPiercing;